import React,{useState} from 'react';
import ReactDOM from "react-dom";    
import styled from "styled-components";
import TextField from '@material-ui/core/TextField';


const Container=styled.div`
position: fixed;
z-index: 9;
top: 0;
left: 0;
bottom: 0;
right: 0;
display: grid;
flex-direction: column;
justify-items:center;
align-items: center;
padding:10px 20px;
background-color: rgba(0, 0, 0, 0.5);`;

const Modal=styled.div`
border-radius:15px;
display:flex;
justify-items:center;
align-items:center;
position:relative;
background-color:white;`;

const ContainerForm=styled.div`
display:grid;
grid-template-columns:50% 50%;
perspective: 1px;
border-radius:30px;
padding:30px;
`;

const ButtonComponent=styled.button`
margin:1%;
background: #08f;
color: #fff;
font-size: .9rem;
padding: .661rem 1rem;
border-radius: 3px;
font-weight: 700;
border: none;
cursor: pointer;
min-width: 5rem;
transition: background-color .1s ease;
outline:none;

@media screen and (max-width:500px)
{
    font-size:20px;
}`;


const Button =({children, onClick})=>
{
    return <ButtonComponent onClick={onClick}>{children}</ButtonComponent>
}

const Input=({type, value,label, setvalue})=>
{
    return <div> <TextField 
    type={type} 
    label={label} 
    value={value} 
    onChange={e => setvalue(e.target.value)} variant="outlined"
    style={{margin:"2%"}}/></div>
}


const AddReserva = ({isOpen,onClose}) => 
{
    const [name, setname] = useState("");
    const [number, setnumber] = useState("");
    const [dinersCount, setdinersCount] = useState(4);
    const [note, setnote] = useState("");
    const [startDate, setstartDate] = useState(undefined);


    if(isOpen)
    {
        return ReactDOM.createPortal(<Container>
            <Modal>
                <ContainerForm>
                        <Input type="text" label="Nombre" value={name} setvalue={setname}/>
                        <Input type="number" label="Número" value={number} setvalue={setnumber}/>
                   
                        <Input type="number" label="?"      value={dinersCount} setvalue={setdinersCount}/>
                        <Input type="text"   label="Notas"  value={note}        setvalue={setnote}/>
                    

                        <TextField variant="outlined" style={{display:"block",margin:"1%",gridColumn: "1/3"}} id="datetime-local" label="Fecha" type="datetime-local" InputLabelProps={{shrink: true}} value={startDate} onChange={(e) => setstartDate(e.target.value)}/>
              
                        <Button onClick={onClose}>Agregar</Button>
                        <Button onClick={onClose}>Cerrar</Button>
                </ContainerForm>
            </Modal>
        </Container>,document.getElementById("modal"));
    }
    else
    {
        return <></>
    }
}

export default AddReserva
